var $name="isMessage",$path="app/utilities/isMessage.js",$this={$name,$path,};import { messages } from 'configs';

// eslint-disable-next-line no-prototype-builtins
const isMessage = (value) => messages.hasOwnProperty(value);

export default isMessage;
